import { createStore } from "vuex";

const store = createStore({
  state: {
    token: null,
    user: null,

    
    cases: [],
    payments:[],
   
    members:[],
    // newMembers:[],
    mpesaPayments:[],
    expenses:[],

    
  },
  mutations: {
    clearToken(context) {
      context.commit("removeToken");
    },
    clearUser(context) {
      context.commit("removeUser");
    },
    addToken(context) {
      context.commit("setToken");
    },

    setUser(state, user) {
      state.user = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    removeToken(state) {
      state.token = null;
    },
    removeUser(state) {
      state.user = null;
    },
    setExpenses(state,expenses) {
      state.expenses = expenses;
    },

    
    
    
    
    setPayments(state, payments) {
      state.payments = payments;
    },
    setMpesapayments(state, mpesaPayments) {
      state.mpesaPayments = mpesaPayments;
    },
    setMembers(state, members){
      state.members=members
    },
    // setNewmembers(state, newMembers){
    //   state.newMembers=newMembers
    // },

    setCases(state, cases){
      state.cases=cases
    }
    
    


   
  },
  actions: {
    clearToken(context) {
      context.commit("removeToken");
    },
    clearUser(context) {
      context.commit("removeUser");
    },
    addToken(context) {
      context.commit("setToken");
    },

    



    async LoadMembers(context) {
      const url = `https://api.roberms.com/twiga/get/members`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const members = [];

      for (const key in responseData) {
        const member = {
          id: key,
          member_id: responseData[key].member_id,
          member_name: responseData[key].member_name,
          member_phone: responseData[key].member_phone,

          registration_amount: responseData[key].registration_amount,
          buffer_amount: responseData[key].buffer_amount,
          previous_balance: responseData[key].previous_balance,
          
          Jan: responseData[key].Jan,
          Feb: responseData[key].Feb,
          March: responseData[key].March,
          April: responseData[key].April,
          May: responseData[key].May,
          June: responseData[key].June,
          July: responseData[key].July,
          August: responseData[key].August,
          September: responseData[key].September,
          October: responseData[key].October,
          November: responseData[key].November,
          December: responseData[key].December,
          Development_amount: responseData[key].Development_amount,
          Project_amount: responseData[key].Project_amount,

          // case_15_amount: responseData[key].case_15,
          wallet_amount: responseData[key].wallet_amount,


          payment_date: responseData[key].payment_date,
          paid_by: responseData[key].paid_by,
          // processed_by: responseData[key].processed_by,
          reference: responseData[key].reference,
          processed: responseData[key].processed,
        };
        members.push(member);
      }
      context.commit("setMembers", members);
    },
    async LoadMpesapayments(context) {
      const url = `https://api.roberms.com/twiga/get/mpesa/payments`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const MpesaPayments = [];

      for (const key in responseData) {
        const payment = {
          id: key,

          FirstName: responseData[key].FirstName,
          TransID: responseData[key].TransID,
          amount: responseData[key].amount,
          payment_date: responseData[key].payment_date,
          account_number: responseData[key].account_number,
          narration: responseData[key].narration,

          payment_reference: responseData[key].payment_reference,
          OrgAccountBalance:responseData[key].OrgAccountBalance,
          processed: responseData[key].processed,
        };
        MpesaPayments.push(payment);
      }
      context.commit("setMpesapayments", MpesaPayments);
    },

    async LoadExpenses(context) {
      const url = `https://api.roberms.com/twiga/get/expenses`;

      const response = await fetch(url, {
        mode: "cors",
        // credentials: "include",
        headers: {
          "Access-Control-Allow-Origin": true,
        },
      });
      const responseData = await response.json();
      if (!response.ok) {
        //
      }
      console.log(responseData);
      const expenses = [];

      for (const key in responseData) {
        const expense = {
          id: key,

          item: responseData[key].item,
          description: responseData[key].description,
          amount: responseData[key].amount,
          paid_to: responseData[key].paid_to,
          expense_date: responseData[key].expense_date,
          processed: responseData[key].processed,
          reference: responseData[key].reference,
          category: responseData[key].category,
        };
        expenses.push(expense);
      }
      context.commit("setExpenses", expenses);
    },

   
  
  
  

   
  
  },
  getters: {
    isLoggedIn() {
      return !!localStorage.getItem("token");
    },

   
    
    twigamembers: (state) => state.members,
    cases:(state)=>state.cases,
    expenses:(state)=> state.expenses,
    // members: (state) => state.members,
    newmembers: (state)=>state.newMembers,
    allPayments: (state) => state.payments,
    allcases: (state) => state.cases,
    membercasePayments: (state)=> (mid) => state.payments.filter(vnumber=>vnumber.case_id==mid),
    allMembers: (state) => state.members,
    memberdetails: (state) => (mid)=>state.members.filter(vnumber=>vnumber.member_idNumber==mid),

    joiningMember: (state) =>(mid)=>state.newMembers.filter(vnumber=>vnumber.member_id==mid),
    mpesaPayments: (state)=>state.mpesaPayments,
    

    voterGetter: (state)=>(vid)=>state.voters.filter(vnumber=>vnumber.id_number==vid),

   casedetails: (state) => (cid)=>state.cases.filter(vnumber=>vnumber.id==cid),


  },


  //
});
export default store;